import { Link } from '@inertiajs/react'
import PublicLayout from '../layouts/PublicLayout'
import Monogram from '../components/Monogram'

export default function Teams({ currentEdition, editions, groups = [] }) {
  const base = `/${currentEdition.slug}`
  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="equipas">
      {groups.map((g) => (
        <div key={g.name}>
          <div className="sechead" style={{ marginBottom: 12 }}>
            <h3 style={{ fontSize: 20 }}>Grupo {g.name}</h3>
            <div className="rule"></div>
          </div>
          <div className="placement" style={{ marginBottom: 22 }}>
            {g.teams.map((t) => (
              <Link
                key={t.slug}
                href={`${base}/equipas/${t.slug}`}
                className="pl"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Monogram team={t} size={22} />
                <b>{t.name}</b>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </PublicLayout>
  )
}
